"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20020ToJSON = exports.InlineResponse20020FromJSONTyped = exports.InlineResponse20020FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineResponse20020FromJSON(json) {
    return InlineResponse20020FromJSONTyped(json, false);
}
exports.InlineResponse20020FromJSON = InlineResponse20020FromJSON;
function InlineResponse20020FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !(0, runtime_1.exists)(json, 'updatedAt') ? undefined : json['updatedAt'],
        'gameId': !(0, runtime_1.exists)(json, 'gameId') ? undefined : json['gameId'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'events': !(0, runtime_1.exists)(json, 'events') ? undefined : json['events'],
        'logo': !(0, runtime_1.exists)(json, 'logo') ? undefined : json['logo'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
        'devourGameLogo': !(0, runtime_1.exists)(json, 'devourGameLogo') ? undefined : json['devourGameLogo'],
        'bannerImageSmall': !(0, runtime_1.exists)(json, 'bannerImageSmall') ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': !(0, runtime_1.exists)(json, 'bannerImageLarge') ? undefined : json['bannerImageLarge'],
        'landingImageSmall': !(0, runtime_1.exists)(json, 'landingImageSmall') ? undefined : json['landingImageSmall'],
        'landingImageLarge': !(0, runtime_1.exists)(json, 'landingImageLarge') ? undefined : json['landingImageLarge'],
        'thumbnailImage': !(0, runtime_1.exists)(json, 'thumbnailImage') ? undefined : json['thumbnailImage'],
        'timeRewardImage': !(0, runtime_1.exists)(json, 'timeRewardImage') ? undefined : json['timeRewardImage'],
        'isEventSupported': !(0, runtime_1.exists)(json, 'isEventSupported') ? undefined : json['isEventSupported'],
        'isEventSupportReady': !(0, runtime_1.exists)(json, 'isEventSupportReady') ? undefined : json['isEventSupportReady'],
        'hasUserStats': !(0, runtime_1.exists)(json, 'hasUserStats') ? undefined : json['hasUserStats'],
        'steamAppId': !(0, runtime_1.exists)(json, 'steamAppId') ? undefined : json['steamAppId'],
        'steamName': !(0, runtime_1.exists)(json, 'steamName') ? undefined : json['steamName'],
        'timeTrackedGame': !(0, runtime_1.exists)(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
        'shortDescription': !(0, runtime_1.exists)(json, 'shortDescription') ? undefined : json['shortDescription'],
        'genres': !(0, runtime_1.exists)(json, 'genres') ? undefined : json['genres'],
        'developers': !(0, runtime_1.exists)(json, 'developers') ? undefined : json['developers'],
        'publishers': !(0, runtime_1.exists)(json, 'publishers') ? undefined : json['publishers'],
        'releaseDate': !(0, runtime_1.exists)(json, 'releaseDate') ? undefined : json['releaseDate'],
        'steamHeaderImage': !(0, runtime_1.exists)(json, 'steamHeaderImage') ? undefined : json['steamHeaderImage'],
        'steamCapsuleImage': !(0, runtime_1.exists)(json, 'steamCapsuleImage') ? undefined : json['steamCapsuleImage'],
        'steamBackground': !(0, runtime_1.exists)(json, 'steamBackground') ? undefined : json['steamBackground'],
        'steamScreenshots': !(0, runtime_1.exists)(json, 'steamScreenshots') ? undefined : json['steamScreenshots'],
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : json['categories'],
        'recommendations': !(0, runtime_1.exists)(json, 'recommendations') ? undefined : json['recommendations'],
        'achievements': !(0, runtime_1.exists)(json, 'achievements') ? undefined : json['achievements'],
        'website': !(0, runtime_1.exists)(json, 'website') ? undefined : json['website'],
    };
}
exports.InlineResponse20020FromJSONTyped = InlineResponse20020FromJSONTyped;
function InlineResponse20020ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'gameId': value.gameId,
        'name': value.name,
        'description': value.description,
        'events': value.events,
        'logo': value.logo,
        'icon': value.icon,
        'devourGameLogo': value.devourGameLogo,
        'bannerImageSmall': value.bannerImageSmall,
        'bannerImageLarge': value.bannerImageLarge,
        'landingImageSmall': value.landingImageSmall,
        'landingImageLarge': value.landingImageLarge,
        'thumbnailImage': value.thumbnailImage,
        'timeRewardImage': value.timeRewardImage,
        'isEventSupported': value.isEventSupported,
        'isEventSupportReady': value.isEventSupportReady,
        'hasUserStats': value.hasUserStats,
        'steamAppId': value.steamAppId,
        'steamName': value.steamName,
        'timeTrackedGame': value.timeTrackedGame,
        'shortDescription': value.shortDescription,
        'genres': value.genres,
        'developers': value.developers,
        'publishers': value.publishers,
        'releaseDate': value.releaseDate,
        'steamHeaderImage': value.steamHeaderImage,
        'steamCapsuleImage': value.steamCapsuleImage,
        'steamBackground': value.steamBackground,
        'steamScreenshots': value.steamScreenshots,
        'categories': value.categories,
        'recommendations': value.recommendations,
        'achievements': value.achievements,
        'website': value.website,
    };
}
exports.InlineResponse20020ToJSON = InlineResponse20020ToJSON;
